module.exports = __webpack_public_path__ + "static/media/5-a_old.ca4e10be.png";